import { configureStore } from '@reduxjs/toolkit'
import appSlice from '../features/appSlice';
import authSlice from '../features/authSlice'
import layoutSlice from '../features/layoutSlice';

const store = configureStore({
    reducer: {
        auth: authSlice,
        app: appSlice,
        layout: layoutSlice
    }
})
export default store;